
  @if(!showpage){

    <div>
      
    </div>
  }
  @else {
    <div class="mtm-container"> 
      @if(shouldShowHeader()){
        <app-header></app-header>
      }
    
    
    </div> 
  }

  <router-outlet></router-outlet>
  
